import React from 'react';
import { Snackbar, Alert } from '@mui/material';
import { useAlbum } from '../../contexts/AlbumContext';

const MessageSnackbar = () => {
  const { message, clearMessage } = useAlbum();

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    clearMessage();
  };

  const getSeverity = () => {
    if (message.type === 'error' || message.text.includes('실패')) {
      return 'error';
    }
    if (message.type === 'warning') {
      return 'warning';
    }
    if (message.type === 'info') {
      return 'info';
    }
    return 'success';
  };

  return (
    <Snackbar
      open={!!message.text}
      autoHideDuration={5000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      sx={{ top: { xs: 70, sm: 80 } }}
    >
      <Alert
        onClose={handleClose}
        severity={getSeverity()}
        variant="filled"
        sx={{
          width: '100%',
          borderRadius: 2,
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        }}
      >
        {message.text}
      </Alert>
    </Snackbar>
  );
};

export default MessageSnackbar;
